import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/inbox')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Outlet />
    </>
  )
}
